export const ZN_PREFIX = 'ZN-'
export const ZN_SUFFIX_LEN = 6

/** Campo codice con prefisso ZN- fisso (non editabile). Suffix: 6 cifre. */
export function znCodeInputHtml(inputId: string, placeholder = '123456'): string {
  return `
    <div class="zn-input-wrap">
      <span class="zn-input-prefix" aria-hidden="true">${ZN_PREFIX}</span>
      <input
        id="${inputId}"
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        class="zn-input-suffix"
        maxlength="${ZN_SUFFIX_LEN}"
        placeholder="${placeholder}"
        autocomplete="off"
        spellcheck="false"
      />
    </div>
  `
}

export function normalizeZnSuffix(raw: string): string {
  let s = raw.trim().toUpperCase()
  if (s.startsWith(ZN_PREFIX)) s = s.slice(ZN_PREFIX.length)
  return s.replace(/\D/g, '').slice(0, ZN_SUFFIX_LEN)
}

export function readZnCodeInput(input: HTMLInputElement): string {
  const suffix = normalizeZnSuffix(input.value)
  return suffix ? `${ZN_PREFIX}${suffix}` : ''
}

export function setZnCodeInput(input: HTMLInputElement, raw: string): void {
  input.value = normalizeZnSuffix(raw)
}

export function wireZnCodeInput(input: HTMLInputElement): void {
  input.addEventListener('input', () => {
    const cleaned = normalizeZnSuffix(input.value)
    if (input.value !== cleaned) input.value = cleaned
  })
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Backspace' && input.selectionStart === 0 && input.selectionEnd === 0) {
      e.preventDefault()
    }
  })
  input.addEventListener('paste', (e) => {
    e.preventDefault()
    const text = e.clipboardData?.getData('text') ?? ''
    input.value = normalizeZnSuffix(text)
    input.dispatchEvent(new Event('input', { bubbles: true }))
  })
}
